<template>
    <div :class="['field-l']">
        <div v-if="title.length" :class="['field__title', [v.$error ? 'field__title-error': '']]">{{title}}</div>
        <div class="field d-flex align-center" :class="inputClasses">
            <img v-if="isSearch" src="../assets/images/textField/search.svg"/>
            <input
                @input="inputHandler"
                @blur="isFocused = false"
                @focus="isFocused = true"
                :disabled="isDisabled"
                type="text" :class="['field__input', [isSearch ? 'field__input-search' : '']]"
                :placeholder="placeholder"
            />
        </div>
        <Validation v-if="v && v.$dirty" :v="v"/>
    </div>
</template>

<script>
    import Validation from "./Validation";

    export default {
        components: {
            Validation,
        },

        data() {
            return {
                isActive: false,
                isFocused: false,
            }
        },

        props: {
            v: {
              type: Object,
              required: false,
            },
            isSearch: {
                type: Boolean,
                required: false,
                default: false
            },
            isDisabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            title: {
                type: String,
                required: false,
                default: '',
            }
        },

        computed: {
            inputClasses() {
                let classes = [];
                if(this.isActive) {
                    classes.push('is-active')
                }
                if(!this.isDisabled && this.v && !this.v.$error && this.isFocused) {
                    classes.push('is-focused')
                }
                if(this.v && this.v.$error) {
                    classes.push('is-error')
                }
                if(this.isDisabled) {
                    classes.push('is-disabled')
                }
                return classes;
            }
        },

        methods: {
            inputHandler(e) {
                const { value } = e.target;

                this.$emit('input', value);

                this.isActive = !!value.length;

                if(this.v) this.v.$touch();
            }
        }
    }
</script>
